// eslint-disable-next-line no-restricted-imports
import { PaletteOptions } from '@mui/material';

import { Colors } from './colors';

/**
 * Defines the palette options for the light theme.
 */
const light: PaletteOptions = {
  error: { main: Colors.red },
  success: { main: Colors.blue500 },
  text: { primary: Colors.black },
  primary: { main: Colors.blue500 },

  backdropBg: 'rgba(12, 24, 44, 0.75)',

  /** SWITCH */
  switchBg: Colors.gray300,
  switchThumb: Colors.white,
  switchBgChecked: Colors.blue200,
  switchThumbChecked: Colors.black,
  switchHoverBorder: Colors.blue50,
  switchDisabledBg: Colors.gray200,
  switchDisabledThumb: Colors.gray300,

  /** SELECT */
  selectBg: Colors.white,
  selectMenuItem: Colors.black,
  selectSelectedMenuItem: Colors.blue200,
  selectMenuItemBorder: Colors.gray50,

  /** CHECKBOX */
  checkboxBorder: Colors.gray300,
  checkboxHover: Colors.gray50,
  checkboxDisabledBg: Colors.gray100,
  checkboxSelectedBorder: Colors.black,
  checkboxSelectedBg: Colors.blue200,
  checkboxSelectedIconBg: Colors.blue700,
  checkboxSelectedHoverIconBg: Colors.blue700,
  checkboxSelectedDisabledIconBg: Colors.gray50,

  /** INPUT */
  inputLabel: Colors.black,
  inputLabelDisabled: Colors.gray500,
  inputPlaceholder: Colors.gray500,
  inputBorder: Colors.gray300,
  inputBorderError: Colors.red,
  inputBorderFocused: Colors.blue500,
  inputBorderHover: Colors.gray500,
  inputFilledBg: Colors.white,
  inputFilledBorder: Colors.gray200,
  inputCompactBg: Colors.gray50,
  inputCompactBorder: Colors.gray200,
};

/**
 * Defines the palette options for the dark theme.
 */
const dark: PaletteOptions = {
  ...light,
};

/**
 * Object that contains palette options for both light and dark themes.
 */
export const palettes = {
  light,
  dark,
};

/**
 * Alias for the palette type of the light theme.
 */
export type PaletteType = typeof light;
